const newspapers = `Tarvitsemmeko vielä sanomalehtiä, kun meillä on internet? Jotkut ihmiset sanovat kyllä, jotkut sanovat ei.
On tärkeää ajatella sitä.
Internet on muuttanut tapaamme saada tietoa.
Tällä on ollut seurauksia sanomalehdille.
Jotkut ihmiset eivät enää osta sanomalehtiä, koska he voivat lukea uutisia verkossa.
Tämä on vaikeuttanut sanomalehtien ansaitsemista, ja jotkut ovat jopa sulkeneet.
Auttaakseen sanomalehtiä ihmiset voivat edelleen ostaa niitä ja tukea paikallista journalismia.
Tämä voi auttaa pitämään ihmiset ajan tasalla siitä, mitä heidän alueellaan tapahtuu.
Verkkolehdissä on hyviä ja huonoja puolia.
He voivat kertoa meille uutisia nopeasti, mutta joskus on vaikea tietää, ovatko ne totta.
Niissä voi myös olla paljon mainoksia, mikä voi olla ärsyttävää.
Tulevaisuudessa asiat voivat muuttua vielä enemmän.
Ehkä useammat ihmiset lukevat uutisia verkossa, ja sanomalehdistä saattaa tulla vähemmän yleisiä.
Mutta on tärkeää, että meillä on hyvää journalismia, olipa se sitten sanomalehdissä tai verkossa, jotta voimme pysyä ajan tasalla ja tietää, mitä maailmassa tapahtuu.`;

export default newspapers;